import React, {useContext, useState, useEffect} from 'react';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import useTheme from '../../components/hooks/useTheme';
import {style} from '../../utils/image';
import {alpha} from '../../utils/color';
import intl from 'react-intl-universal';
import FormSelect from '../../components/ComponentForm/AllForSelect';
import '../../components/ComponentForm/form.scss';
import './index.scss';
import { getNavigator } from "../../components/ComponentNavigator/MainTab";
import {getPageSameType, getLocalConfig, setLocalConfig, toOrderPage } from "../../utils/util";
import ReactSVG from 'react-svg';
import { checkLoadMore, ILoadMoreResult } from "../../components/Common/ListWrapper";
import MyLucky from '../../components/Me/MyLucky';
import BottomModal from '../../components/ButtonGroup/BottomModal';
import {PageContext} from '../../components/ComponentNavigatorV2/PageContext';
import { isInMiniProgram } from 'utils/mini_program';
import { setDocumentTitle } from '../../utils/documentTitle';

export interface ILocalConfig {
  language?:string,
  mode?:string,
  order?:string
}

export interface IPageMe {
  rootStore?:RootStore;
}

const Me = (props:IPageMe)=>{
  const {wxuserStore, localeStore, galleryStore} = props.rootStore!;
  const {user} = wxuserStore;
  const theme = useTheme();
  const loc = intl.getInitOptions().currentLocale;

  const LANGUAGE = [
    {value:"system", label:intl.get('SystemDefault')},
    {value:"zh-CN", label:'简体中文'},
    {value:'en-US', label:"English"}
  ];

  const LAYOUT = [
    // intl.get('One Column'), intl.get('Two Column'), intl.get('Four Column'), intl.get('Timeline'), intl.get('Waterfall')
    {value:"system", label:intl.get('SystemDefault')},
    {value:"1", label:intl.get('One Column')},
    {value:"2", label:intl.get('Two Column')},
    {value:"4", label:intl.get('Four Column')},
    {value:"flow", label:intl.get('Timeline')},
    {value:"waterfall", label:intl.get('Waterfall')},
  ];

  const ORDER = [
    {value:"system", label:intl.get('SystemDefault')},
    {value:'asc', label:intl.get('ASC')},
    {value:'desc', label:intl.get('DESC')}
  ];

  const [setting, setSetting] = useState({
    language:'',
    mode:'',
    order:''
  } as ILocalConfig);

  useEffect(()=>{
    let localSetting = getLocalConfig() as ILocalConfig;
    setSetting(localSetting);
  }, []);

  useEffect(() => {
    setDocumentTitle(undefined, '即享影像 | 企业级即时影像');
  }, []);

  useEffect(()=>{
    if(setting.language && setting.mode && setting.order)
      setLocalConfig(setting);
  }, [setting]);

  const getLanguage = ()=>{
    let exist = LANGUAGE.find((it:any)=>it && it.value == setting.language);
    if(exist) {
      return exist.label;
    }
    return '';
  };

  const getLayout = ()=>{
    let exist = LAYOUT.find((it:any)=>it && it.value == setting.mode);
    if(exist) {
      return exist.label;
    }
    return '';
  };

  const getOrder = ()=>{
    let exist = ORDER.find((it:any)=>it && it.value == setting.order);
    if(exist) {
      return exist.label;
    }
    return '';
  };

  const isShowOrder = () => {
    const navigator = getNavigator();
    // 根据原有逻辑，找不到的话返回true
    return navigator?.order ?? true;
  };

  // const [hasLucky, setHasLucky] = useState(false);
  //
  // useEffect(() => {
  //   let lucky = getPageSameType(window.pageDetail.template, [], "lucky");
  //   if (lucky && lucky.length) {
  //     setHasLucky(true);
  //   }
  // }, []);

  const showLanguage = ()=>{
    if(window.weui) {
      window.weui!.picker(LANGUAGE, {
        onChange: (result: any) => {
          // console.log(`change`, result);
        },
        onConfirm: (result: any) => {
          let target = result[0].value;
          let newSetting = {
            ...setting,
            language:target
          };
          setSetting(newSetting);
          setLocalConfig(newSetting);
          localeStore.setLocale(target);
        },
        title: intl.get('SettingLang')
      });
    }
  };

  const showPhotoLayout = ()=>{
    if(window.weui) {
      window.weui!.picker(LAYOUT, {
        onChange: (result: any) => {
          // console.log(`change`, result);
        },
        onConfirm: (result: any) => {
          let target = result[0].value;
          // galleryStore.setMode(target);
          if(target == 'system') {
            galleryStore.setMode('waterfall');
          }else {
            galleryStore.setMode(target);
          }
          setSetting({
            ...setting,
            mode:target
          });
        },
        title: intl.get('SettingPhotoLayout')
      });
    }
  };

  const showPhotoOrder = ()=>{
    if(window.weui) {
      window.weui!.picker(ORDER, {
        onChange: (result: any) => {
          // console.log(`change`, result);
        },
        onConfirm: (result: any) => {
          let target = result[0].value;
          galleryStore.setOrder(target);
          galleryStore.loadPic({ orderchange: true, notmerge: true });
          setSetting({
            ...setting,
            order:target
          });
        },
        title: intl.get('SettingPhotoSort')
      });
    }
  };

  const [currentScene, setCurrentScene] = useState('');

  const showLuckyList = ()=>{
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return;
    }

    setCurrentScene('lucky');
    luckyRefresh();
  };
  const [luckyPage, setLuckyPage] = useState(1);

  const luckyRefresh = () => {
    setLuckyPage(1);
    return wxuserStore.getLuckyList(1);
  };

  const luckyLoadMore = () => {
    setLuckyPage(luckyPage + 1);
    return wxuserStore.getLuckyList(luckyPage + 1).then(checkLoadMore);
  };

  const context = useContext(PageContext);

  const [lastVisit, setLastVisit] = useState(null as any);

  const fetchLastVisit = async ()=>{
    const last = await wxuserStore.getRecentGallery();
    setLastVisit(last);
  }

  useEffect(()=>{
    if(isInMiniProgram()) {
      fetchLastVisit();
    }
  }, []);

  return <div className="mev2" style={{backgroundColor:theme.backgroundColor}}>
    <div className="mev2-head" onClick={()=>{
      if(user.is_mock) {
        wxuserStore.auth();
      }
    }}>
      <img src={!!user.is_mock ? require("../../assets/avatar-3.png") : user.photo} className="head-photo" />
      <div className="head-nickname" style={{color:theme.h1Color}}>
        {!!user.is_mock ? (
          <a>{intl.get('Login')}</a>
        ) : (
          user.nickname
        )}
      </div>
    </div>
    {/*<MeRecent
      name={intl.get("Recently visited album")}
      gallery={window.gallery}
      onClick={()=>{}}
        />*/}
    {lastVisit && isInMiniProgram() ? <div className="me-recent" style={{ backgroundColor: theme.componentColor }}>
      <div className="shadow-border">
        <span className="row-1" style={{ color: theme.h1Color }}>
          <span style={{ position: "relative", zIndex: 2 }}>{intl.get("Recently visited album")}</span>
          <div className="border" style={{ backgroundColor: theme.mainColor }} />
        </span>
        <div className="row-2">
          <span className="text" style={{ color: theme.h1Color }}>
            {lastVisit.title}
          </span>
          <a
            className="button"
            style={{ color: theme.mainColor }}
            onClick={() => {
              // if (gallery && gallery.link) onClick(gallery.link);
              if(lastVisit && lastVisit.url) {
                const fixedUrl = lastVisit.url.replace(/^http(s*):/, window.location.protocol);
                window.location.href = fixedUrl;
              }
            }}
          >
            {intl.get("Go")}
            <ReactSVG
              src={require("../../svg/right-arrow.svg")}
              style={{ fill: theme.mainColor }}
              className="icon"
            />
          </a>
        </div>
      </div>
    </div> : null}
    <div className="mev2-menus">
      <div className="mev2-menu" onClick={showLanguage} style={{borderColor:alpha(theme.h1Color, 0.1)}}>
        <div className="label">{intl.get('SettingLang')}</div>
        <div className="content" style={{color:theme.h2Color}}>
          <div className="name">{getLanguage()}</div>
          <div className="arrow">
            {"❯"}
          </div>
        </div>
      </div>
      <div className="mev2-menu" onClick={showPhotoLayout} style={{borderColor:alpha(theme.h1Color, 0.1)}}>
        <div className="label">{intl.get('SettingPhotoLayout')}</div>
        <div className="content" style={{color:theme.h2Color}}>
          <div className="name">{getLayout()}</div>
          <div className="arrow">
            {"❯"}
          </div>
        </div>
      </div>
      <div className="mev2-menu" onClick={showPhotoOrder} style={{borderColor:alpha(theme.h1Color, 0.1)}}>
        <div className="label">{intl.get('SettingPhotoSort')}</div>
        <div className="content" style={{color:theme.h2Color}}>
          <div className="name">{getOrder()}</div>
          <div className="arrow">
            {"❯"}
          </div>
        </div>
      </div>
      <div className="mev2-menu" onClick={showLuckyList} style={{borderColor:alpha(theme.h1Color, 0.1)}}>
        <div className="label">{intl.get("My prize")}</div>
        <div className="content" style={{color:theme.h2Color}}>
          <div className="arrow">
            {"❯"}
          </div>
        </div>
      </div>
    </div>
    <div className="mev2-flex1" />
    <div className="mev2-preorder">
      <img
        src={require("../../assets/jf-logo.png")}
        alt="logo"
        className={"logo"}
      />
      <div style={{color:theme.h2Color}}>
        {intl.get("Jimage - Live photo service pioneer")}{" "}
        {isShowOrder() ? (
          <span onClick={()=>{
            toOrderPage('from_order_me');
          }} style={{color:theme.mainColor}}>
            {intl.get("Click to order")}
          </span>
        ) : null}
      </div>
    </div>
    <BottomModal
      title={intl.get('My prize')}
      simpleTitle={true}
      show={currentScene == 'lucky'}
      onHide={() => setCurrentScene('')}
      child={<MyLucky
        list={wxuserStore.luckyList}
        refresh={luckyRefresh}
        loadMore={luckyLoadMore}
      />}
    />
  </div>
};

export default inject("rootStore")(observer(Me));
